/**
 * Menggunakan draft-js
 * Akan ada error Can't call setState on a component that is not yet mounted
 * untuk mengatasi nya, hapus <StrictMode> di index.js, sisakan <App /> nya saja
 *
 * kekurangannya upload gambar menggunakan url,
 * agak ribet menurut saya
 */

import React, { Component } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import "../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";

class TextEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
    };
  }

  onEdiChange(e) {
    this.setState({
      editorState: e,
    });

    this.props.dapatkanData(draftToHtml(convertToRaw(e.getCurrentContent())));
  }

  render() {
    const { editorState } = this.state;
    return (
      <div style={{ width: "80%" }}>
        <Editor
          editorState={editorState}
          wrapperClassName="wrapper-class"
          editorClassName="editor-class"
          toolbarClassName="toolbar-class"
          onEditorStateChange={this.onEdiChange.bind(this)}
        />
        {/* <textarea
          disabled
          value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
        /> */}
      </div>
    );
  }
}

export default TextEditor;
